import { useState } from "react";
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    Paper,
    CircularProgress,
    Modal,
    Dialog,
     DialogTitle,
      DialogContent,
       DialogActions
} from "@mui/material";
import { motion } from "framer-motion";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { buttonGuardar, Input, Texto, TituloPrincipal, SubTitulodos, Icono, BoxPerfil, modalStyle, styleCarga, buttonCancelar, Titulo } from "../Layouts/CustomStyles";
import { useGetPrevision, usePrevision } from "../Services/Prevision";
import Logocolor from "../Image/Logo.png";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import { DiseñoDataGrid } from "../Components/FuncionesGenerales/DataGrid";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";

export const Previsiones = () => {
    const { postPrevision, eliminarPrevision } = usePrevision();
    const { Prevision, loadings, error, refetch: fetchPrevision } = useGetPrevision();
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
const [nuevoNombre, setNuevoNombre] = useState("");


const handleCrearprevision = async () => {
    setEnviandoAlert(true);
    try {
        await postPrevision({ nombre: nuevoNombre });

        setNuevoNombre("");
        setEnviandoAlert(false);
        setSuccessAlertOpen(true);
        setAlertMessage('Se ha creado correctamente la previsión');

        fetchPrevision(); // <--- ESTE ES EL CORRECTO
        setOpenDialog(false); // cerrar modal después de crear
    } catch (error) {
        setEnviandoAlert(false);
        setErrorAlertOpen(true);
        setAlertMessage("Error al crear previsión");
    }
};

const handleEliminarPrevision = async (id) => {
    setEnviandoAlert(true);

    try {
        await eliminarPrevision(id);

        setEnviandoAlert(false);
        setSuccessAlertOpen(true);
        setAlertMessage("La previsión ha sido eliminada correctamente.");

        fetchPrevision(); // refresca la tabla
    } catch (error) {
        setEnviandoAlert(false);
        setErrorAlertOpen(true);
        setAlertMessage("Error al eliminar previsión");
    }
};


    if (loadings) return <Box display="flex" justifyContent="center" mt={4} sx={styleCarga}>
        <CircularProgress />
    </Box>;
    if (error) return <p>{error}</p>;
    return (
        <Container maxWidth="lg" sx={{ py: 5 }}>
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <Paper
                    elevation={4}
                    sx={{
                        p: 4,
                        borderRadius: "20px",
                        background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    }}
                >
                    <Box display="flex" alignItems="center" gap={2} mb={4}>
                        <img
                            src={Logocolor}
                            alt="Logo Clínica Activa"
                            style={{ width: 55, height: 55, objectFit: "contain" }}
                        />
                        <Typography variant="h5" sx={TituloPrincipal}>
                            Previsiones
                        </Typography>
                    </Box>
                    <Box sx={{display:"flex", alignItems:'flex-end', justifyContent:'flex-end', mb:3}}>
                        <Button
     startIcon={<AddCircleOutlineIcon />}
                            variant="contained"
                            sx={{
                                backgroundColor: "#2a8d74",
                                borderRadius: "50px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                            }}
    onClick={() => setOpenDialog(true)}
>
    Agregar Previsión
</Button>

                    </Box>
                    <Box sx={{ height: 450, width: "100%" }}>
                        <DataGrid
                            rows={Prevision}
                            columns={[


                                {
                                    field: "nombre",
                                    headerName: "Nombre de Previsión",
                                    flex: 1,
                                },

                                {
                                    field: "acciones",
                                    headerName: "Acciones",
                                    flex: 1,
                                    renderCell: (params) => (
                                        <Button
                                            variant="contained"
                                            color="error"
                                            size="small"
                                            startIcon={<DeleteIcon />}
                                            onClick={() => handleEliminarPrevision(params.row.id)}
                                        >
                                            Eliminar
                                        </Button>
                                    ),
                                },
                            ]}
                            pageSize={5}
                            rowsPerPageOptions={[5]}
                            disableSelectionOnClick
                            getRowId={(row) => row.id}
                            slots={{ noRowsOverlay: DiseñoDataGrid }}
                            sx={{
                                fontFamily: 'Poppins, sans-serif',
                                '& .MuiDataGrid-columnHeaders': {
                                    color: '#113e21ff',
                                    fontWeight: 600,
                                    textTransform: 'capitalize',
                                },
                                '& .MuiDataGrid-cell': {
                                    textTransform: 'capitalize',
                                },
                            }}
                        />
                    </Box>
                </Paper>
            </motion.div>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}maxWidth="md" fullWidth>
    <DialogTitle sx={Titulo}>Agregar Nueva Previsión</DialogTitle>

    <DialogContent>
        <TextField
        
            autoFocus
            fullWidth
            label="Nombre de Previsión"
            variant="outlined"
            value={nuevoNombre}
            onChange={(e) => setNuevoNombre(e.target.value)}
            sx={{ ...Input, mt: 1 }}
        />
    </DialogContent>

    <DialogActions>
        <Button sx={buttonCancelar} onClick={() => setOpenDialog(false)}>Cancelar</Button>

        <Button
            variant="contained"
            sx={buttonGuardar}
            onClick={() => { 
    handleCrearprevision(); 
    setOpenDialog(false);
}}

        >
            Guardar
        </Button>
    </DialogActions>
</Dialog>

            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </Container>
    )
}